import { Api } from '@/src/store/api'

export const MortgageEarnApi = Api.enhanceEndpoints({
  endpoints: {
    'POST /mortgage/earn': {
      invalidatesTags: ['GET /mortgage/earn'],
    },
    'POST /mortgage/earn/:earnId/uploads/:uploadId/complete': {
      invalidatesTags: ['GET /mortgage/earn'],
    },
  },
})
